var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMikeListening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_linear_5140_10253)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5140_10253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5140_10253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 26.1429C21.8095 26.1429 20.7976 25.7262 19.9643 24.8929C19.131 24.0595 18.7143 23.0476 18.7143 21.8571V13.2857C18.7143 12.0952 19.131 11.0833 19.9643 10.25C20.7976 9.41667 21.8095 9 23 9C24.1905 9 25.2024 9.41667 26.0357 10.25C26.869 11.0833 27.2857 12.0952 27.2857 13.2857V21.8571C27.2857 23.0476 26.869 24.0595 26.0357 24.8929C25.2024 25.7262 24.1905 26.1429 23 26.1429ZM21.5714 36.1429V31.75C19.0952 31.4167 17.0476 30.3095 15.4286 28.4286C13.8095 26.5476 13 24.3571 13 21.8571H15.8571C15.8571 23.8333 16.5536 25.5179 17.9464 26.9107C19.3393 28.3036 21.0238 29 23 29C24.9762 29 26.6607 28.3036 28.0536 26.9107C29.4464 25.5179 30.1429 23.8333 30.1429 21.8571H33C33 24.3571 32.1905 26.5476 30.5714 28.4286C28.9524 30.3095 26.9048 31.4167 24.4286 31.75V36.1429H21.5714Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5140_10253",
    x1: 8.20333,
    y1: 8.43333,
    x2: 44.1929,
    y2: 32.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikeListening);
export default __webpack_public_path__ + "static/media/mike_listening.60eb94869a3ed9d10196807587c60d19.svg";
export { ForwardRef as ReactComponent };